// Central icon resolver using lucide-react. Given an icon name (kebab-case slug), return the component.
import {
    Briefcase,
    Building2,
    GraduationCap,
    Users,
    CalendarDays,
    Handshake,
    HeartPulse,
    BookOpen,
    LifeBuoy,
    Trees,
    HeartHandshake,
    TrendingUp,
    Award,
    Newspaper,
    Phone,
    Mail,
    MapPin,
    Facebook,
    Twitter,
    Instagram,
    Youtube,
    Linkedin,
    Download,
    FileText,
    Play,
    Image as ImageIcon,
    ArrowRight,
    ArrowUpRight,
    ChevronDown,
    Menu,
    X,
    LogOut,
    LayoutDashboard,
    Sparkles,
    Target,
    Eye,
    Compass,
    ShieldCheck,
    ChevronRight,
    CheckCircle2,
    Copy,
    QrCode,
    Search,
    Heart,
    Star,
    Zap,
    Trash2,
    Pencil,
    Plus,
    Save,
    Loader2,
    Inbox,
    ExternalLink,
    Settings,
    Package,
    Camera,
    Trophy,
    Send,
} from 'lucide-react';

const ICONS = {
    briefcase: Briefcase,
    'building-2': Building2,
    'graduation-cap': GraduationCap,
    users: Users,
    'calendar-days': CalendarDays,
    handshake: Handshake,
    'heart-pulse': HeartPulse,
    'book-open': BookOpen,
    'life-buoy': LifeBuoy,
    trees: Trees,
    'heart-handshake': HeartHandshake,
    'trending-up': TrendingUp,
    award: Award,
    newspaper: Newspaper,
    phone: Phone,
    mail: Mail,
    'map-pin': MapPin,
    facebook: Facebook,
    twitter: Twitter,
    instagram: Instagram,
    youtube: Youtube,
    linkedin: Linkedin,
    download: Download,
    'file-text': FileText,
    play: Play,
    image: ImageIcon,
    'arrow-right': ArrowRight,
    'arrow-up-right': ArrowUpRight,
    'chevron-down': ChevronDown,
    menu: Menu,
    x: X,
    'log-out': LogOut,
    'layout-dashboard': LayoutDashboard,
    sparkles: Sparkles,
    target: Target,
    eye: Eye,
    compass: Compass,
    'shield-check': ShieldCheck,
    'chevron-right': ChevronRight,
    'check-circle-2': CheckCircle2,
    copy: Copy,
    'qr-code': QrCode,
    search: Search,
    heart: Heart,
    star: Star,
    zap: Zap,
    'trash-2': Trash2,
    pencil: Pencil,
    plus: Plus,
    save: Save,
    'loader-2': Loader2,
    inbox: Inbox,
    'external-link': ExternalLink,
    settings: Settings,
    package: Package,
    camera: Camera,
    trophy: Trophy,
    send: Send,
};

export const getIcon = (name) => ICONS[name] || Sparkles;
